module.exports = __webpack_public_path__ + "img/projects.b70042a6.svg";